import { Adapter as n } from "../../../../../adapter.js";
import { ShopSessionUserModel as r } from "./user.model.js";
class s extends n {
  adapt(e) {
    return new r({
      name: e.full_name ?? e.name,
      email: e.email,
      phone: e.phone_number,
      externalId: e.external_id
    });
  }
  serialize(e) {
    return {
      name: e.name,
      email: e.email,
      phone_number: e.phone,
      external_id: (e == null ? void 0 : e.externalId) || null
    };
  }
}
export {
  s as ShopSessionUserAdapter
};
//# sourceMappingURL=user.adapter.js.map
